<script setup lang="ts">
  import { ref, reactive } from 'vue';
  import SvgIcon from '@/components/common/SvgIcon/SvgIcon.vue';
  import type { ExposedIconButtonProps, IconName, IconSize } from '@/types';

  type Props = {
    icon: IconName;
    label: string;
    /**
     * Quantité de padding à ajouter autour de l'image par rapport au bouton. Valeurs selon la config. de TailwindCSS.
     */
    imageSpacing?: boolean;
    size?: IconSize;
  };

  defineOptions({ name: 'IconButton' });

  defineEmits<{
    click: [event: Event];
  }>();

  withDefaults(defineProps<Props>(), {
    imageSpacing: true,
    size: 'smaller',
  });

  const buttonRef = ref<HTMLButtonElement>();

  defineExpose<ExposedIconButtonProps>(reactive({ buttonRef }));
</script>

<template>
  <button
    ref="buttonRef"
    :class="imageSpacing ? 'p-1' : undefined"
    class="box-content flex-none rounded cursor-pointer"
    type="button"
    :aria-label="label"
    @click="$emit('click', $event)"
  >
    <SvgIcon
      :icon="icon"
      :size="size"
      class="pointer-events-none"
    />
  </button>
</template>
